var i = /(https:\/\/.*)\/analytics\.js\/v1\/(?:.*?)\/(?:platform|analytics.*)?/, o = function() {
  var r, t = Array.prototype.slice.call(document.querySelectorAll("script"));
  return t.forEach(function(l) {
    var n, c = (n = l.getAttribute("src")) !== null && n !== void 0 ? n : "", e = i.exec(c);
    e && e[1] && (r = e[1]);
  }), r;
}, a, s = function() {
  var r, t = a ?? ((r = window.analytics) === null || r === void 0 ? void 0 : r._cdn);
  return t;
}, u = function(r) {
  window.analytics && (window.analytics._cdn = r), a = r;
}, v = function() {
  var r = s();
  if (r)
    return r;
  var t = o();
  return t || "https://cdn.segment.com";
}, d = function() {
  var r = v();
  return "".concat(r, "/next-integrations");
};
export {
  v as getCDN,
  d as getNextIntegrationsURL,
  u as setGlobalCDNUrl
};
//# sourceMappingURL=index31.js.map
